import { Link } from "react-router-dom";

export function BackToDesk() {
  return (
    <Link className="back-desk" to="/">
      ← back to the desk
    </Link>
  );
}
